import { MijnRoute } from '../mijn-navigatie.model';

export const SECURITY_AWARENESS_TRAINING: MijnRoute = {
    path: 'security-awareness-training',
    navigationEvent: 'toSecurityAwareness',
    regex: /^\/security-awareness-training$/,
    webcomponent: 'mijn-klant-security-awareness'
};
